import {
  Box,
  Drawer as MuiDrawer,
  IconButton,
  SvgIcon,
  SxProps,
  Theme,
  Typography
} from '@mui/material';
import React, { FC, PropsWithChildren } from 'react';
import { CloseIcon } from '../../../../icons';

type Props = {
  label: string;
  open: boolean;
  closeDrawer: (event: React.MouseEvent) => void;
  headIcon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  sx?: SxProps<Theme>;
};

export type DrawerProps = Props;

export const Drawer: FC<PropsWithChildren<Props>> = ({
  label,
  open,
  closeDrawer,
  headIcon,
  children,
  sx = []
}) => {
  return (
    <MuiDrawer
      open={open}
      onClose={closeDrawer}
      anchor="right"
      sx={{
        '& .MuiDrawer-paper': {
          padding: '32px',
          boxSizing: 'border-box',
          borderRadius: '8px 0px 0px 8px',
          width: {
            sm: '500px',
            xs: '100%'
          }
        },
        ...(Array.isArray(sx) ? sx : [sx])
      }}
      PaperProps={{ square: false }}
    >
      <>
        <Box
          display={'flex'}
          justifyContent={'space-between'}
          sx={{
            marginBottom: '32px'
          }}
        >
          <Box display={'flex'} alignItems={'center'}>
            {headIcon && (
              <SvgIcon
                component={headIcon}
                sx={{
                  marginRight: '20px',
                  width: '32px',
                  height: '32px'
                }}
              />
            )}
            <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
              {label}
            </Typography>
          </Box>
          <Box>
            <IconButton onClick={closeDrawer}>
              <SvgIcon component={CloseIcon} color="primary" />
            </IconButton>
          </Box>
        </Box>
        <div className="border border-t-0 border-solid border-grey-50 mx-[-32px] mb-8" />
        {children}
      </>
    </MuiDrawer>
  );
};
